'use client';

import { ArrowLeft, RefreshCw } from 'lucide-react';
import Link from 'next/link';
import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <h1 className="text-text-primary text-4xl font-semibold tracking-tight md:text-5xl">
        Something went wrong
      </h1>
      <p className="text-text-secondary mt-4 max-w-md text-lg">
        An unexpected error occurred. Please try again or go back to the
        homepage.
      </p>
      <div className="mt-8 flex gap-4">
        <button
          onClick={reset}
          className="flex items-center gap-2 rounded-full bg-[radial-gradient(74.03%_95.19%_at_48.09%_47.12%,#14CCB7_0%,#13B8A5_100%)] px-6 py-3 text-sm font-medium text-white shadow-[0px_2px_4px_rgba(19,184,165,0.3),inset_0px_3px_3px_rgba(255,255,255,0.2)] transition-opacity hover:opacity-90"
        >
          <RefreshCw size={16} /> Try again
        </button>
        <Link
          href="/"
          className="text-text-secondary hover:text-text-primary flex items-center gap-2 rounded-full border border-current/10 px-6 py-3 text-sm font-medium transition-colors"
        >
          <ArrowLeft size={16} /> Back to Home
        </Link>
      </div>
    </main>
  );
}
